// extracted by mini-css-extract-plugin
module.exports = {"dialogBody":"FeedbackModal_dialogBody__1Mnw-"};